<script>
    import {createEventDispatcher} from 'svelte';

    import store from '../../../Stores/tipo-de-jornada-store';

    import Subtitulo from "../../UI/Subtitulo.svelte";
    import CampoDeTexto from "../../UI/CampoDeTexto.svelte";

    const dispatch = createEventDispatcher();

    let tipoDeJornada, error, errores = {};
    $: tipoDeJornada = $store.tipo;

    const actualizaCampo = (campo, valor) => store.actualizaCampo(campo, valor);
</script>

<div class="sin-horario">
    <Subtitulo>Sin horario</Subtitulo>

    <CampoDeTexto id="duracion" label="Duración (minutos)" value={tipoDeJornada.duracion}
                  icono="timer" valido={!errores.duracion} type="number"
                  mensajeDeError={errores.duracion} disabled={tipoDeJornada.protegido}
                  on:input={e => actualizaCampo('duracion', e.target.value)}/>
</div>